import axios from 'axios';
import {BASE_URL, token} from '../../utils/const';
import {Toast} from '../../utils/sweetAlert';
import {t} from 'react-switch-lang';
import Swal from 'sweetalert2';

export function AddNotificationApi(data) {
  return axios({
    method: 'POST',
    url: `${BASE_URL}/notifications/reminder`,
    data: data,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successAdd')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      Swal.fire({
        text: `${t('message.errorApi')}!`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

export function GetUnreadNotificationApi() {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/notifications/unread/count`,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((r) => r.data)
    .catch((error) => {
      Swal.fire({
        text: `${t('message.errorApi')}!`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

// export function GetReminderNotificationsByDocumentApi(id) {
//   return axios({
//     method: 'GET',
//     url: `${BASE_URL}/notifications/document/${id}`,
//     headers: {
//       Accept: '*/*',
//       'Content-Type': 'application/json',
//       Authorization: 'Bearer ' + token,
//     },
//   })
//     .then((r) => r.data)
//     .catch((error) => {
//       Swal.fire({
//         text: `${t('message.errorApi')}!`,
//         icon: 'error',
//         confirmButtonText: 'OK',
//       });
//     });
// }

export function EditNotificationApi(data) {
  return axios({
    method: 'PUT',
    url: `${BASE_URL}/notifications/reminder`,
    data: data,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successEdit')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      if (error.response.data.message === 'notification-update') {
        Swal.fire({
          text: `${t('message.editErrorNotification')}!`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          text: `${t('message.errorApi')}!`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    });
}

export function MarkAsReadApi(id) {
  return axios({
    method: 'PUT',
    url: `${BASE_URL}/notifications/${id}/mark-as-read`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  })
    .then((r) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successMoveToRead')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      Swal.fire({
        text: `${error}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

export function DeleteNotificationApi(id) {
  return axios({
    method: 'DELETE',
    url: `${BASE_URL}/notifications/${id}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  })
    .then((r) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successDelete')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      Swal.fire({
        text: `${error}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

export function MarkAllNotificationAsReadApi() {
  return axios({
    method: 'PUT',
    url: `${BASE_URL}/notifications/mark-all-as-read`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  })
    .then((r) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successEdit')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      Swal.fire({
        text: `${error}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

export function DeleteAllNotificationApi(type) {
  return axios({
    method: 'DELETE',
    url: `${BASE_URL}/notifications/delete-all/${type}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  })
    .then((r) => {
      Toast.fire({
        icon: 'success',
        title: `${t('message.successDelete')}!`,
      });
      return 'success';
    })
    .catch((error) => {
      Swal.fire({
        text: `${error}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    });
}

// export const GetGlobalNotificationsApi = (pageNumber) => {
//   return axios({
//     method: 'GET',
//     url: `${BASE_URL}/notifications/global?page=${pageNumber}&size=20&sort=createdAt,desc`,
//     headers: {
//       Authorization: 'Bearer ' + token,
//       Accept: '*/*',
//     },
//   });
// };

// export const DeleteGlobalNotificationsApi = (id) => {
//   return axios({
//     method: 'DELETE',
//     url: `${BASE_URL}/notifications/global/${id}/delete`,
//     headers: {
//       Authorization: 'Bearer ' + token,
//       Accept: '*/*',
//       'Content-Type': 'application/json',
//     },
//   });
// };

// export function AddGlobalNotificationApi(data) {
//   return axios({
//     method: 'POST',
//     url: `${BASE_URL}/notifications/global/create`,
//     data: data,
//     headers: {
//       Accept: '*/*',
//       'Content-Type': 'application/json',
//       Authorization: 'Bearer ' + token,
//     },
//   });
// }
